import { Input, Component, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';


@Component({
    selector: 'toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnInit
{
    constructor() { }

    ngOnInit(): void
    {
    }

    @Input() isChecked: boolean;
    @Input() isDisabled: boolean;

    @Output('change')
    public change: EventEmitter<any> = new EventEmitter();

    public toggle()
    {
        if (this.isDisabled) return;

        this.change.emit();
    }
}
